import { jsx as s } from "react/jsx-runtime";
import y from "classnames";
import { useId as a, useCallback as b, useMemo as w } from "react";
import { ReactSVG as x } from "react-svg";
const f = window.APP_CONFIG ?? {}, c = {
  configJsonUrl: f.CONFIG_JSON_URL,
  dataJsonUrl: f.DATA_JSON_URL,
  basePath: f.BASE_PATH
}, C = ({
  size: t = "small",
  path: r,
  color: i,
  allowStaticRender: u,
  className: p,
  alt: e = "",
  ...m
}) => {
  const d = a(), g = b(
    (o) => {
      if (i && o.setAttribute("fill", i), typeof t == "number" || typeof t == "object") {
        const n = h(t);
        n.width && (o.style.width = n.width), n.height && (o.style.height = n.height);
      }
      if (e) {
        const n = document.createElement("title");
        n.textContent = e, n.id = d, o.insertBefore(n, o.firstChild);
      }
    },
    [i, t, e, d]
  ), l = w(() => ({ color: i }), [i]);
  return /* @__PURE__ */ s(
    "span",
    {
      className: y(
        "ds-icon",
        {
          ["ds-icon--" + t]: typeof t == "string"
        },
        p
      ),
      "aria-hidden": !e,
      ...m,
      children: !P(r) || u ? /* @__PURE__ */ s(
        "img",
        {
          src: `${c.basePath ?? "/"}icons/${S(r)}`,
          alt: e,
          style: typeof t == "number" || typeof t == "object" ? h(t) : void 0
        }
      ) : /* @__PURE__ */ s(
        x,
        {
          wrapper: "span",
          beforeInjection: g,
          src: `${c.basePath ?? "/"}icons/${r}.svg`,
          "aria-hidden": !e,
          style: l,
          "aria-labelledby": e ? d : void 0,
          role: e ? "img" : void 0
        }
      )
    }
  );
}, h = (t) => typeof t == "number" ? {
  width: t + "px",
  height: t + "px"
} : {
  width: typeof t.width > "u" ? void 0 : typeof t.width == "string" ? t.width : t.width + "px",
  height: typeof t.height > "u" ? void 0 : typeof t.height == "string" ? t.height : t.height + "px"
}, P = (t) => t.includes(".") ? t.split(".").pop() === "svg" : !0, S = (t) => t.includes(".") ? t : t + ".svg";
export {
  C as I
};
//# sourceMappingURL=Icon-BcAne5bE.js.map
